import React from 'react';

export const Page2257 = React.lazy(() => import('./Page2257'));
